<template>
  <b-overlay class="loading-area"
    fixed :show="pendingRequests>0"
    variant="white"
    spinner-variant="secondary"
    spinner-type="border"
    no-wrap>
    <template #overlay>
        <div class="text-center">
          <b-spinner style="width: 3rem; height: 3rem;"
            variant="secondary"
          ></b-spinner><br>
          <b-button
            ref="cancel"
            variant="outline-secondary"
            size="xs"
            aria-describedby="cancel-label"
            @click="resetPendingRequests"
            class="mt-5"
          >
            {{$t('general.cancel')}}
          </b-button>
        </div>
      </template>
  </b-overlay>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  computed: {
    pendingRequests () {
      if (this.$store.state.pendingRequests ) {
        return this.$store.state.pendingRequests;
      } else {
        return 0;
      }
    }
  },
  methods: {
    resetPendingRequests () {
      this.$store.commit("resetPendingRequests");
    }
  }

}
</script>

<style scoped>
  .loading-area {

  }
</style>
